module.exports = "/assets/login/registerFormPhoto.jpg?b8R9yep";